import { Box, Checkbox, Divider, FormControlLabel, FormGroup, Typography } from "@mui/material";
import type { FC } from "react";
import { TripTagCategory } from "../../components/tagSelect/tags";
import { useTripTagsByCategory } from "../../orders/useTripTagsByCategory";
import { useTagParams } from "../../publicPackages2/filter/useTagParams";

export interface Tag {
  readonly category: string;
  readonly value: string;
}

interface TagGroupProps {
  readonly category: string;
  readonly tags: string[];
  readonly selectedTags: Tag[];
  readonly onSelect: (tag: Tag) => void;
  readonly onUnselect: (tag: Tag) => void;
}

const TagGroup: FC<TagGroupProps> = ({ category, tags, selectedTags, onSelect, onUnselect }) => (
  <Box>
    <Typography
      variant="subtitle2"
      sx={{
        fontWeight: "bold",
        color: "text.secondary",
        textTransform: "uppercase",
        mb: 1,
      }}
    >
      {category}
    </Typography>
    <FormGroup
      sx={
        isGrid(category)
          ? {
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 0,
              maxHeight: 180,
              overflowY: "auto",
              overflowX: "hidden",
              pr: 1,
            }
          : undefined
      }
    >
      {tags.map((it) => (
        <FormControlLabel
          key={it}
          control={<Checkbox size="small" />}
          checked={!!selectedTags.find((st) => st.category === category && st.value === it)}
          value={it}
          onChange={(_, checked) => (checked ? onSelect({ category, value: it }) : onUnselect({ category, value: it }))}
          label={<Typography variant="body2">{it}</Typography>}
        />
      ))}
    </FormGroup>
  </Box>
);

export interface PublicPackagesSearchCriteria {
  readonly tags: Tag[];
}

const isGrid = (category: string) => category == TripTagCategory.COUNTRY;

const TagFiltersMenu = () => {
  const { tripTagsByCategory } = useTripTagsByCategory();
  const { tags: selectedTags, setTags } = useTagParams();

  return (
    <>
      {Object.entries(tripTagsByCategory ?? {}).map(([category, tags], index, entries) => (
        <div key={category}>
          <TagGroup
            category={category}
            tags={tags}
            selectedTags={selectedTags}
            onSelect={(t) => setTags([...selectedTags, t])}
            onUnselect={(t) => setTags(selectedTags.filter((st) => st.category !== t.category || st.value !== t.value))}
          />
          {index < entries.length - 1 && <Divider />}
        </div>
      ))}
    </>
  );
};

export default TagFiltersMenu;
